module.exports = __webpack_public_path__ + "img/Netsmart_logo_people_only.2c228def.png";